"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memberGrade = void 0;
var utils_1 = require("../../utils");
var qs = require("qs");
exports.memberGrade = function (axios) {
    return {
        getMemberGrades: function (request) {
            return axios.get('/member-grades', request);
        },
        postMemberGrades: function (request) {
            return axios.post('/member-grades', request.data);
        },
        putMemberGrades: function (request) {
            return axios.put('/member-grades', request.data);
        },
        getMemberGradesGradeNo: function (request) {
            var url = utils_1.paramPathchange('/member-grades/{gradeNo}', request);
            return axios.get(url);
        },
        putMemberGradesGradeNo: function (request) {
            var url = utils_1.paramPathchange('/member-grades/{gradeNo}', request);
            return axios.put(url, request.data);
        },
        deleteMemberGrades: function (request) {
            var query = qs.stringify(request.params);
            return axios.delete("/member-grades?" + query);
        },
        deleteMemberGradesGradeNo: function (request) {
            var url = utils_1.paramPathchange('/member-grades/{gradeNo}', request);
            return axios.delete(url);
        },
        getMemberGradesConfigurationsEvaluation: function (request) {
            return axios.get('/member-grades/configurations/evaluation', request);
        },
        putMemberGradesConfigurationsEvaluation: function (request) {
            return axios.put('/member-grades/configurations/evaluation', request.data);
        },
        putMemberGradesGradeNoOrder: function (request) {
            var url = utils_1.paramPathchange('/member-grades/{gradeNo}/order', request);
            return axios.put(url, request.data);
        },
        putMemberGradesGradeNoUsed: function (request) {
            var url = utils_1.paramPathchange('/member-grades/{gradeNo}/used', request);
            return axios.put(url);
        },
        getMemberGradesGrids: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/member-grades/grids?" + query);
        },
        postMemberGradesBenefits: function (request) {
            return axios.post('/member-grades/benefits', request.data);
        },
        putMemberGradesBenefit: function (request) {
            var url = utils_1.paramPathchange('/member-grades/{gradeNo}/benefit', request);
            return axios.put(url);
        }
    };
};
